


import Swal from 'sweetalert2';

export const DialogValidation = ({messageErr}) => {
  return Swal.fire({
     title:'Aviso',
     text: messageErr !== '' || messageErr !== null ? messageErr : 'NA',
     icon:'warning'
  });
};
